module.exports = __webpack_public_path__ + "/login_ui/img/to-5f7ede6679b043a8092fba037a84debb.svg";